import React from 'react';

import SettingsAccount from 'Skelet/src/components/Settings.js'
import SettingsPassword from 'Skelet/src/components/SettingsPassword.js'

import config from '../config.js'


export default class extends React.Component {

  render() {
    return <div className="container thin-container content">
      <SettingsAccount
        lang = "EN"
        config = {config}
        fields = {[{type:"display", dbcol:"email", placeholder:"Emailadres"},
        {type:"text", dbcol:"firstname", placeholder:"First name", maxLength:"128"},
        {type:"text", dbcol:"lastname", placeholder:"Last name", maxLength:"128"}]}
        required_fields = {[{dbcol:"firstname", name:"First name"}, {dbcol:"lastname", name:"Last name"}]}
        validate_fields = {[{dbcol:"firstname", name:"First name"}, {dbcol:"lastname", name:"Last name"}]}
        api_method = "PATCH"
        api_endpoint = "/account-update?lang=en"
        api_block = "update_account"
      />
      <div style={{marginTop:"2em"}}>
        <SettingsPassword
          lang = "EN"
          config = {config}
          api_method = "PATCH"
          api_endpoint = "/account-update?lang=en"
          api_block = "update_account"
        />
      </div>
    </div>
  }

}



// WEBPACK FOOTER //
// ./src/containers/Settings.js